import styled, {css} from 'styled-components'
import {Container} from '@components/ui/container/Container.tsx'

export const StyledContainer = styled(Container)`
    ${({theme: {palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: ${palette.neutral[700]};
        opacity: 0.8;
    `}
`

export const StyledErrorWrapper = styled.div`
    ${({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        gap: ${spacing * 6}px;
        max-width: 1024px;
        width: 100%;

        & h1 {
            ${typography.displayMd};
            font-weight: 600;
            color: ${palette.neutral.white};
            text-align: center;
        }
    `}
`
